const customStyles = (styles?: any) => ({
  control: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    minWidth: 140,
    marginRight: 24,
    fontSize: 13,
    backgroundColor: "#f3f7fa",
    border: "1px solid #cbdfea",
    ...(styles ?? {}),
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: 14,
  }),
})

export const maxWidthStyle = {
  control: (provided: any) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    minWidth: 140,
    maxWidth: 240,
    fontSize: 13,
    marginRight: 24,
    backgroundColor: "#f3f7fa",
    border: "1px solid #cbdfea",
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: 14,
  }),
}

export default customStyles
